(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.header =
        document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

      if (this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();

    }

    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }

    disconnectedCallback() {

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }

    createObserver() {

      let observer =
        new IntersectionObserver(
          (entries, observer) => {

            this.headerBounds =
              entries[0].intersectionRect;

            observer.disconnect();

          }
        );

      observer.observe(
        this.header
      );

    }

    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) {
          return;
        }

        requestAnimationFrame(
          this.hide.bind(this)
        );

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        } else {

          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(() => {

              this.preventReveal = false;

            }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );

      }

      this.currentScrollTop =
        scrollTop;

    }

    hide() {

      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();

    }

    reveal() {

      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }

    reset() {

      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }

    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) => disclosure.close()
      );

    }

    closeSearchModal() {

      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );

      if (this.searchModal) {
        this.searchModal.close(false);
      }

    }

  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );

  if (!customElements.get('zara-mobile-menu')) {
    class ZaraMobileMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.openButton = this.querySelector('[data-zmm-open]');
        this.dialog = this.querySelector('[data-zmm-dialog]');
        this.closeButton = this.querySelector('[data-zmm-close]');
        this.tabsContainer = this.querySelector('[data-zmm-tabs]');
        this.tabs = Array.from(this.querySelectorAll('[data-zmm-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-zmm-panel]'));
        this.scrollArea = this.querySelector('[data-zmm-scroll]');
        this.slider = this.querySelector('[data-zmm-slider]');
        this.sliderTrack = this.querySelector('[data-zmm-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-zmm-slide]'));
        this.nextButton = this.querySelector('[data-zmm-next]');
        this.desktopHeader = this.closest('.header');
        this.desktopMegaMenus = Array.from(
          this.desktopHeader?.querySelectorAll('header-menu .mega-menu') || []
        );
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.slideIndex = 0;
        this.sliderTimer = null;
        this.restoreFocusOnClose = true;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        if (!this.openButton || !this.dialog) return;

        this.openButton.addEventListener('click', () => this.openMenu(), { signal });
        this.closeButton?.addEventListener('click', () => this.closeMenu(true), { signal });
        this.dialog.addEventListener('close', () => this.afterClose(), { signal });
        this.dialog.addEventListener('cancel', () => {
          this.restoreFocusOnClose = true;
        }, { signal });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.closeMenu(true);
            return;
          }

          const backButton = event.target.closest('[data-zmm-category-back]');
          if (backButton) {
            event.preventDefault();
            this.resetCategoryView(true);
            return;
          }

          const categoryCard = event.target.closest('[data-zmm-open-category]');
          const normalClick = !event.defaultPrevented && event.button === 0 &&
            !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
          if (categoryCard && normalClick && this.openCategory(categoryCard)) {
            event.preventDefault();
            this.restoreFocusOnClose = true;
            return;
          }

          const destination = event.target.closest('a[href]');
          if (destination) this.restoreFocusOnClose = false;
        }, { signal });

        this.tabsContainer?.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-zmm-tab]');
          if (!tab) return;
          this.activateTab(Number(tab.dataset.zmmTab), false);
        }, { signal });

        this.tabsContainer?.addEventListener('keydown', (event) => this.onTabKeydown(event), { signal });
        this.nextButton?.addEventListener('click', () => {
          this.advanceSlider();
          this.startSlider();
        }, { signal });

        this.sliderTrack?.addEventListener('pointerdown', () => this.stopSlider(), { signal });
        this.sliderTrack?.addEventListener('pointerup', () => this.startSlider(), { signal });
        this.sliderTrack?.addEventListener('pointercancel', () => this.startSlider(), { signal });
        this.sliderTrack?.addEventListener('focusin', () => this.stopSlider(), { signal });
        this.sliderTrack?.addEventListener('focusout', () => this.startSlider(), { signal });

        this.syncDesktopMegaMenuLogo = () => {
          const hasOpenMegaMenu =
            this.desktopQuery.matches && this.desktopMegaMenus.some((menu) => menu.open);

          this.desktopHeader?.classList.toggle('zmm-desktop-mega-open', hasOpenMegaMenu);
          document.documentElement.classList.toggle('zmm-desktop-mega-open', hasOpenMegaMenu);
        };

        this.desktopMegaMenus.forEach((menu) => {
          menu.addEventListener('toggle', this.syncDesktopMegaMenuLogo, { signal });
        });

        this.onDesktopChange = (event) => {
          if (event.matches && this.dialog.open) this.closeMenu(false);
          this.syncDesktopMegaMenuLogo();
        };
        this.desktopQuery.addEventListener('change', this.onDesktopChange);
        this.syncDesktopMegaMenuLogo();
      }

      disconnectedCallback() {
        this.resetCategoryView();
        this.abortController?.abort();
        this.desktopQuery?.removeEventListener('change', this.onDesktopChange);
        this.stopSlider();
        this.pauseVideos();
        this.desktopHeader?.classList.remove('zmm-desktop-mega-open');
        document.documentElement.classList.remove('zmm-desktop-mega-open');
        delete this.dataset.initialized;

        if (this.dialog?.open) {
          this.dialog.close();
        }

        if (!document.querySelector('.zmm__dialog[open]')) {
          document.documentElement.classList.remove('zmm-is-open');
        }
      }

      openMenu() {
        if (this.dialog.open || this.desktopQuery.matches) return;

        this.previouslyFocused = document.activeElement;
        this.restoreFocusOnClose = true;

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        this.openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('zmm-is-open');
        this.closeButton?.focus();

        const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        selectedTab?.scrollIntoView({ block: 'nearest', inline: 'center' });

        this.playVideos();
        this.startSlider();
      }

      closeMenu(restoreFocus = true) {
        if (!this.dialog.open) return;

        this.restoreFocusOnClose = restoreFocus;

        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.afterClose();
        }
      }

      afterClose() {
        this.resetCategoryView();
        this.openButton?.setAttribute('aria-expanded', 'false');
        this.stopSlider();
        this.pauseVideos();

        if (!document.querySelector('.zmm__dialog[open]')) {
          document.documentElement.classList.remove('zmm-is-open');
        }

        if (this.restoreFocusOnClose && this.previouslyFocused instanceof HTMLElement) {
          this.previouslyFocused.focus();
        }
      }

      activateTab(index, moveFocus = false) {
        if (!Number.isInteger(index)) return;
        const activeTab = this.tabs.find((tab) => Number(tab.dataset.zmmTab) === index);
        if (!activeTab) return;

        this.resetCategoryView();

        this.tabs.forEach((tab) => {
          const isActive = Number(tab.dataset.zmmTab) === index;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = Number(panel.dataset.zmmPanel) !== index;
        });
        const behavior = this.reducedMotionQuery.matches ? 'auto' : 'smooth';
        activeTab.scrollIntoView({ behavior, block: 'nearest', inline: 'center' });

        if (moveFocus) activeTab.focus();
        this.scrollArea?.scrollTo({ top: 0, behavior: 'auto' });
      }

      openCategory(card) {
        const panel = card.closest('[data-zmm-panel]');
        if (!this.dialog.open || this.desktopQuery.matches || !panel || panel.hidden || !this.contains(panel)) {
          return false;
        }

        const group = Array.from(panel.querySelectorAll('details[data-zmm-category]'))
          .find((candidate) => candidate.id === card.dataset.zmmOpenCategory);
        const item = group?.closest('.zmm__category-item');
        const list = item?.parentElement;
        const backButton = panel.querySelector('[data-zmm-category-back]');
        if (!group || !item || !list?.classList.contains('zmm__category-list') || !backButton) {
          return false;
        }

        this.resetCategoryView();

        const items = Array.from(list.children);
        const groups = items.flatMap((entry) => Array.from(entry.querySelectorAll('details.zmm__group')));
        const features = Array.from(panel.querySelectorAll('.zmm__features'));
        const hiddenElements = [...items, ...features];
        if (this.slider) hiddenElements.push(this.slider);

        // Preserve the complete panel so Back, tab changes and closing restore it exactly.
        const state = {
          card,
          panel,
          group,
          backButton,
          scrollTop: this.scrollArea?.scrollTop || 0,
          hiddenStates: hiddenElements.map((element) => ({ element, hidden: element.hidden })),
          openStates: groups.map((element) => ({ element, open: element.open })),
          expanded: card.getAttribute('aria-expanded')
        };
        this.categoryView = state;
        this.stopSlider();

        items.forEach((entry) => { entry.hidden = entry !== item; });
        features.forEach((feature) => { feature.hidden = true; });
        groups.forEach((entry) => { entry.open = entry === group; });
        if (this.slider) this.slider.hidden = true;
        backButton.hidden = false;
        card.setAttribute('aria-expanded', 'true');
        backButton.focus({ preventScroll: true });

        requestAnimationFrame(() => {
          if (this.categoryView !== state || !this.dialog.open) return;
          this.scrollArea?.scrollTo({
            top: 0,
            behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth'
          });
        });
        return true;
      }

      resetCategoryView(returnToCard = false) {
        const state = this.categoryView;
        if (!state) return;

        this.categoryView = null;
        state.hiddenStates.forEach(({ element, hidden }) => { element.hidden = hidden; });
        state.openStates.forEach(({ element, open }) => { element.open = open; });
        state.backButton.hidden = true;
        if (state.expanded === null) {
          state.card.removeAttribute('aria-expanded');
        } else {
          state.card.setAttribute('aria-expanded', state.expanded);
        }
        this.scrollArea?.scrollTo({ top: state.scrollTop, behavior: 'auto' });

        if (returnToCard && this.dialog.open && state.card.isConnected && !state.panel.hidden) {
          state.card.focus({ preventScroll: true });
        }
        if (this.isConnected) this.startSlider();
      }

      onTabKeydown(event) {
        const currentTab = event.target.closest('[data-zmm-tab]');
        if (!currentTab) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        const isRtl = getComputedStyle(this).direction === 'rtl';
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = isRtl ? currentIndex - 1 : currentIndex + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = isRtl ? currentIndex + 1 : currentIndex - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
        this.activateTab(Number(this.tabs[nextIndex].dataset.zmmTab), true);
      }

      advanceSlider() {
        if (this.slides.length < 2) return;

        this.slideIndex = (this.slideIndex + 1) % this.slides.length;
        const behavior = this.reducedMotionQuery.matches ? 'auto' : 'smooth';
        this.slides[this.slideIndex].scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
      }

      startSlider() {
        this.stopSlider();

        if (!this.dialog.open || this.categoryView || this.slides.length < 2 || this.reducedMotionQuery.matches) return;

        const delay = Number(this.slider?.dataset.autoplay || 0);
        if (!Number.isFinite(delay) || delay < 3000) return;

        this.sliderTimer = window.setInterval(() => this.advanceSlider(), delay);
      }

      stopSlider() {
        if (this.sliderTimer) {
          window.clearInterval(this.sliderTimer);
          this.sliderTimer = null;
        }
      }

      playVideos() {
        this.dialog.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          const promise = video.play();
          if (promise?.catch) promise.catch(() => {});
        });
      }

      pauseVideos() {
        this.dialog?.querySelectorAll('video').forEach((video) => video.pause());
      }
    }

    customElements.define('zara-mobile-menu', ZaraMobileMenu);
  }


  } catch(e) { console.error(e); }
})();
})();
